// Generated by barrles.ps1

export * from "./main-menu.component";
